import { Union } from "./.fable/fable-library.3.2.9/Types.js";
import { union_type, int32_type } from "./.fable/fable-library.3.2.9/Reflection.js";
import { Node$, node_print, Node$$reflection } from "./Parser.fs.js";
import { printf, toText } from "./.fable/fable-library.3.2.9/String.js";
import { Token } from "./Lexer.fs.js";
import { equals } from "./.fable/fable-library.3.2.9/Util.js";
import { ofArrayWithTail, empty, ofArray, singleton, append, cons, head, tail, isEmpty } from "./.fable/fable-library.3.2.9/List.js";
import { rev } from "./Helper.fs.js";

export class ProofLine extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PropositionLine", "NegElimLine", "AlphaLine", "BetaLine", "EtaLine", "OpenLine", "CloseLine", "BranchLine"];
    }
}

export function ProofLine$reflection() {
    return union_type("Propositional.ProofLine", [], ProofLine, () => [[["Item1", int32_type], ["Item2", Node$$reflection()]], [["Item1", int32_type], ["Item2", ProofLine$reflection()], ["Item3", Node$$reflection()]], [["Item1", int32_type], ["Item2", ProofLine$reflection()], ["Item3", Node$$reflection()]], [["Item1", int32_type], ["Item2", ProofLine$reflection()], ["Item3", ProofLine$reflection()], ["Item4", Node$$reflection()]], [["Item1", int32_type], ["Item2", ProofLine$reflection()], ["Item3", ProofLine$reflection()], ["Item4", Node$$reflection()]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", ProofLine$reflection()], ["Item3", ProofLine$reflection()]], [["Item1", int32_type], ["Item2", Node$$reflection()]]]);
}

export class ProofTree extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["End", "Continuous", "Branch"];
    }
}

export function ProofTree$reflection() {
    return union_type("Propositional.ProofTree", [], ProofTree, () => [[["Item", ProofLine$reflection()]], [["Item1", ProofLine$reflection()], ["Item2", ProofTree$reflection()]], [["Item1", ProofTree$reflection()], ["Item2", ProofTree$reflection()]]]);
}

export class ProofBranchLine extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Root", "Line"];
    }
}

export function ProofBranchLine$reflection() {
    return union_type("Propositional.ProofBranchLine", [], ProofBranchLine, () => [[], [["Item1", ProofLine$reflection()], ["Item2", ProofBranchLine$reflection()]]]);
}

export function get_line(line) {
    switch (line.tag) {
        case 1: {
            const ln_1 = line.fields[0] | 0;
            return ln_1 | 0;
        }
        case 2: {
            const ln_2 = line.fields[0] | 0;
            return ln_2 | 0;
        }
        case 3: {
            const ln_3 = line.fields[0] | 0;
            return ln_3 | 0;
        }
        case 4: {
            const ln_4 = line.fields[0] | 0;
            return ln_4 | 0;
        }
        case 5: {
            const ln_5 = line.fields[0] | 0;
            return ln_5 | 0;
        }
        case 6: {
            const ln_6 = line.fields[0] | 0;
            return ln_6 | 0;
        }
        case 7: {
            const ln_7 = line.fields[0] | 0;
            return ln_7 | 0;
        }
        default: {
            const ln = line.fields[0] | 0;
            return ln | 0;
        }
    }
}

export function print_format_line(tab, formula) {
    if (tab === 0) {
        switch (formula.tag) {
            case 1: {
                const src = formula.fields[1];
                const node_1 = formula.fields[2];
                const ln_1 = formula.fields[0] | 0;
                const src_ln = get_line(src) | 0;
                const arg30 = node_print(node_1);
                return toText(printf("%d: \u003cDNE %d\u003e: %s\n"))(ln_1)(src_ln)(arg30);
            }
            case 2: {
                const src_1 = formula.fields[1];
                const node_2 = formula.fields[2];
                const ln_2 = formula.fields[0] | 0;
                const src_ln_1 = get_line(src_1) | 0;
                const arg30_1 = node_print(node_2);
                return toText(printf("%d: \u003cA %d\u003e: %s\n"))(ln_2)(src_ln_1)(arg30_1);
            }
            case 3: {
                const node_3 = formula.fields[3];
                const ln_3 = formula.fields[0] | 0;
                const beta_min = formula.fields[2];
                const beta_max = formula.fields[1];
                const bmax_ln = get_line(beta_max) | 0;
                const bmin_ln = get_line(beta_min) | 0;
                const arg40 = node_print(node_3);
                return toText(printf("%d: \u003cB %d %d\u003e: %s\n"))(ln_3)(bmax_ln)(bmin_ln)(arg40);
            }
            case 4: {
                const node_4 = formula.fields[3];
                const ln_4 = formula.fields[0] | 0;
                const eta_min = formula.fields[2];
                const eta_max = formula.fields[1];
                const emax_ln = get_line(eta_max) | 0;
                const emin_ln = get_line(eta_min) | 0;
                const arg40_1 = node_print(node_4);
                return toText(printf("%d: \u003cE %d %d\u003e: %s\n"))(ln_4)(emax_ln)(emin_ln)(arg40_1);
            }
            case 5: {
                const ln_5 = formula.fields[0] | 0;
                return toText(printf("%d: \u003cO\u003e\n\n"))(ln_5);
            }
            case 6: {
                const ln_6 = formula.fields[0] | 0;
                const close_min = formula.fields[2];
                const close_max = formula.fields[1];
                const cmax_ln = get_line(close_max) | 0;
                const cmin_ln = get_line(close_min) | 0;
                return toText(printf("%d: \u003cC %d %d\u003e\n\n"))(ln_6)(cmax_ln)(cmin_ln);
            }
            case 7: {
                const node_5 = formula.fields[1];
                const ln_7 = formula.fields[0] | 0;
                const arg20_6 = node_print(node_5);
                return toText(printf("%d: \u003cB\u003e: %s\n"))(ln_7)(arg20_6);
            }
            default: {
                const node = formula.fields[1];
                const ln = formula.fields[0] | 0;
                const arg20 = node_print(node);
                return toText(printf("%d: \u003cP\u003e: %s\n"))(ln)(arg20);
            }
        }
    }
    else {
        const tab_1 = tab | 0;
        const arg10_8 = print_format_line(tab_1 - 1, formula);
        return toText(printf(" %s"))(arg10_8);
    }
}

export function print_format_tree(tab, tree) {
    switch (tree.tag) {
        case 1: {
            const tree_1 = tree.fields[1];
            const line_1 = tree.fields[0];
            const arg20 = print_format_tree(tab, tree_1);
            const arg10 = print_format_line(tab, line_1);
            return toText(printf("%s%s"))(arg10)(arg20);
        }
        case 2: {
            const right = tree.fields[1];
            const left = tree.fields[0];
            const arg20_1 = print_format_tree(tab + 1, right);
            const arg10_1 = print_format_tree(tab + 1, left);
            return toText(printf("%s%s"))(arg10_1)(arg20_1);
        }
        default: {
            const line = tree.fields[0];
            return print_format_line(tab, line);
        }
    }
}

export function print_tree(tree) {
    return print_format_tree(0, tree);
}

export function json_from_tree_line(formula) {
    switch (formula.tag) {
        case 1: {
            const src = formula.fields[1];
            const node_1 = formula.fields[2];
            const ln_1 = formula.fields[0] | 0;
            const src_ln = get_line(src) | 0;
            const arg30 = node_print(node_1);
            return toText(printf("{\"type\": \"ne\", \"ln\": %d, \"src\": %d, \"formula\": \"%s\"}"))(ln_1)(src_ln)(arg30);
        }
        case 2: {
            const src_1 = formula.fields[1];
            const node_2 = formula.fields[2];
            const ln_2 = formula.fields[0] | 0;
            const src_ln_1 = get_line(src_1) | 0;
            const arg30_1 = node_print(node_2);
            return toText(printf("{\"type\": \"a\", \"ln\": %d, \"src\": %d, \"formula\": \"%s\"}"))(ln_2)(src_ln_1)(arg30_1);
        }
        case 3: {
            const node_3 = formula.fields[3];
            const ln_3 = formula.fields[0] | 0;
            const beta_min = formula.fields[2];
            const beta_max = formula.fields[1];
            const bmax_ln = get_line(beta_max) | 0;
            const bmin_ln = get_line(beta_min) | 0;
            const arg40 = node_print(node_3);
            return toText(printf("{\"type\": \"b\", \"ln\": %d, \"src\": %d, \"min_src\": %d, \"formula\": \"%s\"}"))(ln_3)(bmax_ln)(bmin_ln)(arg40);
        }
        case 4: {
            const node_4 = formula.fields[3];
            const ln_4 = formula.fields[0] | 0;
            const eta_min = formula.fields[2];
            const eta_max = formula.fields[1];
            const emax_ln = get_line(eta_max) | 0;
            const emin_ln = get_line(eta_min) | 0;
            const arg40_1 = node_print(node_4);
            return toText(printf("{\"type\": \"e\", \"ln\": %d, \"src\": %d, \"min_src\": %d, \"formula\": \"%s\"}"))(ln_4)(emax_ln)(emin_ln)(arg40_1);
        }
        case 5: {
            const ln_5 = formula.fields[0] | 0;
            return toText(printf("{\"type\": \"o\", \"ln\": %d}"))(ln_5);
        }
        case 6: {
            const ln_6 = formula.fields[0] | 0;
            const close_min = formula.fields[2];
            const close_max = formula.fields[1];
            const cmax_ln = get_line(close_max) | 0;
            const cmin_ln = get_line(close_min) | 0;
            return toText(printf("{\"type\": \"c\", \"ln\": %d, \"src\": %d, \"min_src\": %d}"))(ln_6)(cmax_ln)(cmin_ln);
        }
        case 7: {
            const node_5 = formula.fields[1];
            const ln_7 = formula.fields[0] | 0;
            const arg20_6 = node_print(node_5);
            return toText(printf("{\"type\": \"br\", \"ln\": %d, \"formula\": \"%s\"}"))(ln_7)(arg20_6);
        }
        default: {
            const node = formula.fields[1];
            const ln = formula.fields[0] | 0;
            const arg20 = node_print(node);
            return toText(printf("{\"type\": \"p\", \"ln\": %d, \"formula\": \"%s\"}"))(ln)(arg20);
        }
    }
}

export function json_from_tree_helper(tree) {
    switch (tree.tag) {
        case 1: {
            const tree_1 = tree.fields[1];
            const line_1 = tree.fields[0];
            const arg20 = json_from_tree_helper(tree_1);
            const arg10 = json_from_tree_line(line_1);
            return toText(printf("%s, %s"))(arg10)(arg20);
        }
        case 2: {
            const right = tree.fields[1];
            const left = tree.fields[0];
            const arg20_1 = json_from_tree_helper(right);
            const arg10_1 = json_from_tree_helper(left);
            return toText(printf("{\"type\": \"bc\", \"left\": [%s], \"right\": [%s]}"))(arg10_1)(arg20_1);
        }
        default: {
            const line = tree.fields[0];
            return json_from_tree_line(line);
        }
    }
}

export function json_from_tree(tree) {
    return ("[" + json_from_tree_helper(tree)) + "]";
}

export function remove_neg(node_mut) {
    remove_neg:
    while (true) {
        const node = node_mut;
        let pattern_matching_result, operand;
        if (node.tag === 0) {
            if (node.fields[0].tag === 6) {
                if (node.fields[1].tag === 0) {
                    if (node.fields[1].fields[0].tag === 6) {
                        pattern_matching_result = 0;
                        operand = node.fields[1].fields[1];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                node_mut = operand;
                continue remove_neg;
            }
            case 1: {
                return node;
            }
        }
        break;
    }
}

export function negate(node) {
    return remove_neg(new Node$(0, new Token(6), node));
}

export function in_branch(node_mut, line_mut) {
    let ln_10, l_node_10, ln_8, l_node_8, b_2, a_6, ln_6, l_node_6, b, a_4, ln_4, l_node_4, a_2, ln_2, l_node_2, a, ln, l_node;
    in_branch:
    while (true) {
        const node = node_mut, line = line_mut;
        let pattern_matching_result, l_node_1, ln_1;
        if (line.tag === 1) {
            if (line.fields[0].tag === 0) {
                if ((ln = (line.fields[0].fields[0] | 0), (l_node = line.fields[0].fields[1], equals(l_node, node)))) {
                    pattern_matching_result = 1;
                    l_node_1 = line.fields[0].fields[1];
                    ln_1 = line.fields[0].fields[0];
                }
                else {
                    pattern_matching_result = 2;
                }
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 0;
        }
        switch (pattern_matching_result) {
            case 0: {
                return void 0;
            }
            case 1: {
                return new ProofLine(0, ln_1, l_node_1);
            }
            case 2: {
                let pattern_matching_result_1, a_1, l_node_3, ln_3;
                if (line.tag === 1) {
                    if (line.fields[0].tag === 1) {
                        if ((ln_2 = (line.fields[0].fields[0] | 0), (l_node_2 = line.fields[0].fields[2], (a = line.fields[0].fields[1], equals(l_node_2, node))))) {
                            pattern_matching_result_1 = 0;
                            a_1 = line.fields[0].fields[1];
                            l_node_3 = line.fields[0].fields[2];
                            ln_3 = line.fields[0].fields[0];
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        return new ProofLine(1, ln_3, a_1, l_node_3);
                    }
                    case 1: {
                        let pattern_matching_result_2, a_3, l_node_5, ln_5;
                        if (line.tag === 1) {
                            if (line.fields[0].tag === 2) {
                                if ((ln_4 = (line.fields[0].fields[0] | 0), (l_node_4 = line.fields[0].fields[2], (a_2 = line.fields[0].fields[1], equals(l_node_4, node))))) {
                                    pattern_matching_result_2 = 0;
                                    a_3 = line.fields[0].fields[1];
                                    l_node_5 = line.fields[0].fields[2];
                                    ln_5 = line.fields[0].fields[0];
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                        switch (pattern_matching_result_2) {
                            case 0: {
                                return new ProofLine(2, ln_5, a_3, l_node_5);
                            }
                            case 1: {
                                let pattern_matching_result_3, a_5, b_1, l_node_7, ln_7;
                                if (line.tag === 1) {
                                    if (line.fields[0].tag === 3) {
                                        if ((ln_6 = (line.fields[0].fields[0] | 0), (l_node_6 = line.fields[0].fields[3], (b = line.fields[0].fields[2], (a_4 = line.fields[0].fields[1], equals(l_node_6, node)))))) {
                                            pattern_matching_result_3 = 0;
                                            a_5 = line.fields[0].fields[1];
                                            b_1 = line.fields[0].fields[2];
                                            l_node_7 = line.fields[0].fields[3];
                                            ln_7 = line.fields[0].fields[0];
                                        }
                                        else {
                                            pattern_matching_result_3 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_3 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_3 = 1;
                                }
                                switch (pattern_matching_result_3) {
                                    case 0: {
                                        return new ProofLine(3, ln_7, a_5, b_1, l_node_7);
                                    }
                                    case 1: {
                                        let pattern_matching_result_4, a_7, b_3, l_node_9, ln_9;
                                        if (line.tag === 1) {
                                            if (line.fields[0].tag === 4) {
                                                if ((ln_8 = (line.fields[0].fields[0] | 0), (l_node_8 = line.fields[0].fields[3], (b_2 = line.fields[0].fields[2], (a_6 = line.fields[0].fields[1], equals(l_node_8, node)))))) {
                                                    pattern_matching_result_4 = 0;
                                                    a_7 = line.fields[0].fields[1];
                                                    b_3 = line.fields[0].fields[2];
                                                    l_node_9 = line.fields[0].fields[3];
                                                    ln_9 = line.fields[0].fields[0];
                                                }
                                                else {
                                                    pattern_matching_result_4 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_4 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_4 = 1;
                                        }
                                        switch (pattern_matching_result_4) {
                                            case 0: {
                                                return new ProofLine(4, ln_9, a_7, b_3, l_node_9);
                                            }
                                            case 1: {
                                                let pattern_matching_result_5, l_node_11, ln_11;
                                                if (line.tag === 1) {
                                                    if (line.fields[0].tag === 7) {
                                                        if ((ln_10 = (line.fields[0].fields[0] | 0), (l_node_10 = line.fields[0].fields[1], equals(l_node_10, node)))) {
                                                            pattern_matching_result_5 = 0;
                                                            l_node_11 = line.fields[0].fields[1];
                                                            ln_11 = line.fields[0].fields[0];
                                                        }
                                                        else {
                                                            pattern_matching_result_5 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_5 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_5 = 1;
                                                }
                                                switch (pattern_matching_result_5) {
                                                    case 0: {
                                                        return new ProofLine(7, ln_11, l_node_11);
                                                    }
                                                    case 1: {
                                                        if (line.tag === 1) {
                                                            const prev = line.fields[1];
                                                            node_mut = node;
                                                            line_mut = prev;
                                                            continue in_branch;
                                                        }
                                                        else {
                                                            throw (new Error("Match failure"));
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        break;
    }
}

export function neg_in_branch(node, line) {
    return in_branch(negate(node), line);
}

export function prop_helper(ln_mut, nodes_mut, passed_mut, tree_mut) {
    let op_1;
    prop_helper:
    while (true) {
        const ln = ln_mut, nodes = nodes_mut, passed = passed_mut, tree = tree_mut;
        let prev;
        if (tree.tag === 1) {
            const line = tree.fields[0];
            prev = line;
        }
        else {
            prev = (void 0);
        }
        if (!isEmpty(nodes)) {
            const nodes_1 = tail(nodes);
            const node_1 = head(nodes);
            const matchValue = neg_in_branch(node_1, tree);
            if (matchValue == null) {
                switch (node_1.tag) {
                    case 0: {
                        const operand = node_1.fields[1];
                        const op_3 = node_1.fields[0];
                        if (op_3.tag === 6) {
                            switch (operand.tag) {
                                case 0: {
                                    const operand_1 = operand.fields[1];
                                    const op_5 = operand.fields[0];
                                    if (op_5.tag === 6) {
                                        const new_node = remove_neg(operand_1);
                                        let prev_instr_line;
                                        const matchValue_1 = in_branch(node_1, tree);
                                        if (matchValue_1 != null) {
                                            const prev_2 = matchValue_1;
                                            prev_instr_line = prev_2;
                                        }
                                        else {
                                            throw (new Error("This should be unreachable."));
                                        }
                                        const instr = new ProofLine(1, ln, prev_instr_line, new_node);
                                        const down_tree_1 = new ProofBranchLine(1, instr, tree);
                                        const up_tree_1 = prop_helper(ln + 1, cons(new_node, nodes_1), passed, down_tree_1);
                                        return new ProofTree(1, instr, up_tree_1);
                                    }
                                    else {
                                        throw (new Error("This should be unreachable"));
                                    }
                                }
                                case 2: {
                                    ln_mut = ln;
                                    nodes_mut = nodes_1;
                                    passed_mut = passed;
                                    tree_mut = tree;
                                    continue prop_helper;
                                }
                                default: {
                                    const right_1 = operand.fields[2];
                                    const op_4 = operand.fields[0];
                                    const left_2 = operand.fields[1];
                                    switch (op_4.tag) {
                                        case 3: {
                                            throw (new Error("This should be unreachable."));
                                        }
                                        case 5: {
                                            return beta_helper(ln, nodes_1, passed, tree, node_1, negate(left_2), negate(right_1));
                                        }
                                        case 4: {
                                            return alpha_helper(ln, nodes_1, passed, tree, node_1, negate(left_2), negate(right_1));
                                        }
                                        case 7: {
                                            return alpha_helper(ln, nodes_1, passed, tree, node_1, left_2, negate(right_1));
                                        }
                                        case 8: {
                                            return eta_helper(ln, nodes_1, passed, tree, node_1, left_2, negate(right_1));
                                        }
                                        default: {
                                            throw (new Error("This should be unreachable."));
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            throw (new Error("This should be unreachable."));
                        }
                    }
                    case 2: {
                        ln_mut = ln;
                        nodes_mut = nodes_1;
                        passed_mut = passed;
                        tree_mut = tree;
                        continue prop_helper;
                    }
                    default: {
                        const right = node_1.fields[2];
                        const op = node_1.fields[0];
                        const left_1 = node_1.fields[1];
                        switch (op.tag) {
                            case 3: {
                                const instr_line = new ProofLine(0, ln, left_1);
                                const down_tree = new ProofBranchLine(1, instr_line, tree);
                                let pattern_matching_result;
                                if (right.tag === 1) {
                                    if ((op_1 = right.fields[0], equals(op_1, new Token(3)))) {
                                        pattern_matching_result = 0;
                                    }
                                    else {
                                        pattern_matching_result = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                                switch (pattern_matching_result) {
                                    case 0: {
                                        const next_up_tree = prop_helper(ln + 1, append(nodes_1, singleton(right)), cons(left_1, passed), down_tree);
                                        return new ProofTree(1, instr_line, next_up_tree);
                                    }
                                    case 1: {
                                        const next_instr_line = new ProofLine(0, ln + 1, right);
                                        const next_down_tree = new ProofBranchLine(1, next_instr_line, down_tree);
                                        const up_tree = prop_helper(ln + 2, append(rev(passed), ofArray([left_1, right])), empty(), next_down_tree);
                                        return new ProofTree(1, instr_line, new ProofTree(1, next_instr_line, up_tree));
                                    }
                                }
                            }
                            case 5: {
                                return alpha_helper(ln, nodes_1, passed, tree, node_1, left_1, right);
                            }
                            case 4: {
                                return beta_helper(ln, nodes_1, passed, tree, node_1, left_1, right);
                            }
                            case 7: {
                                return beta_helper(ln, nodes_1, passed, tree, node_1, negate(left_1), right);
                            }
                            case 8: {
                                return eta_helper(ln, nodes_1, passed, tree, node_1, left_1, right);
                            }
                            default: {
                                ln_mut = ln;
                                nodes_mut = nodes_1;
                                passed_mut = passed;
                                tree_mut = tree;
                                continue prop_helper;
                            }
                        }
                    }
                }
            }
            else {
                const line_1 = matchValue;
                if (prev != null) {
                    const prev_1 = prev;
                    return new ProofTree(0, new ProofLine(6, ln, line_1, prev_1));
                }
                else {
                    throw (new Error("This should be unreachable."));
                }
            }
        }
        else if (!isEmpty(passed)) {
            const node = head(passed);
            if (node.tag === 1) {
                const left = node.fields[1];
                const true_branch_line = new ProofLine(7, ln, left);
                const true_down_tree = new ProofBranchLine(1, true_branch_line, tree);
                const true_up_tree = prop_helper(ln + 1, passed, empty(), true_down_tree);
                const true_branch_tree = new ProofTree(1, true_branch_line, true_up_tree);
                const false_branch_line = new ProofLine(7, ln, negate(left));
                const false_down_tree = new ProofBranchLine(1, false_branch_line, tree);
                const false_up_tree = prop_helper(ln + 1, passed, empty(), false_down_tree);
                const false_branch_tree = new ProofTree(1, false_branch_line, false_up_tree);
                return new ProofTree(2, true_branch_tree, false_branch_tree);
            }
            else {
                throw (new Error("This should be unreachable"));
            }
        }
        else {
            return new ProofTree(0, new ProofLine(5, ln));
        }
        break;
    }
}

export function alpha_helper(ln, nodes, passed, tree, node, left, right) {
    let prev_instr_line;
    const matchValue = in_branch(node, tree);
    if (matchValue != null) {
        const prev = matchValue;
        prev_instr_line = prev;
    }
    else {
        throw (new Error("This should be unreachable."));
    }
    const left_instr = new ProofLine(2, ln, prev_instr_line, left);
    const right_instr = new ProofLine(2, ln + 1, prev_instr_line, right);
    const down_tree = new ProofBranchLine(1, left_instr, new ProofBranchLine(1, right_instr, tree));
    const up_tree = prop_helper(ln + 2, append(ofArrayWithTail([left, right], nodes), passed), empty(), down_tree);
    return new ProofTree(1, left_instr, new ProofTree(1, right_instr, up_tree));
}

export function beta_helper(ln, nodes, passed, tree, node, left, right) {
    let prev_instr_line;
    const matchValue = in_branch(node, tree);
    if (matchValue != null) {
        const prev = matchValue;
        prev_instr_line = prev;
    }
    else {
        throw (new Error("This should be unreachable."));
    }
    const matchValue_1 = in_branch(left, tree);
    if (matchValue_1 == null) {
        const matchValue_2 = in_branch(right, tree);
        if (matchValue_2 == null) {
            const matchValue_3 = neg_in_branch(left, tree);
            if (matchValue_3 == null) {
                const matchValue_4 = neg_in_branch(right, tree);
                if (matchValue_4 == null) {
                    return prop_helper(ln, nodes, cons(node, passed), tree);
                }
                else {
                    const right_line = matchValue_4;
                    const left_instr_line = new ProofLine(3, ln, prev_instr_line, right_line, left);
                    const down_tree_1 = new ProofBranchLine(1, left_instr_line, tree);
                    const up_tree_1 = prop_helper(ln + 1, cons(left, nodes), passed, down_tree_1);
                    return new ProofTree(1, left_instr_line, up_tree_1);
                }
            }
            else {
                const left_line = matchValue_3;
                const right_instr_line = new ProofLine(3, ln, prev_instr_line, left_line, right);
                const down_tree = new ProofBranchLine(1, right_instr_line, tree);
                const up_tree = prop_helper(ln + 1, cons(right, nodes), passed, down_tree);
                return new ProofTree(1, right_instr_line, up_tree);
            }
        }
        else {
            return prop_helper(ln, nodes, passed, tree);
        }
    }
    else {
        return prop_helper(ln, nodes, passed, tree);
    }
}

export function eta_helper(ln, nodes, passed, tree, node, left, right) {
    let prev_instr_line;
    const matchValue = in_branch(node, tree);
    if (matchValue != null) {
        const prev = matchValue;
        prev_instr_line = prev;
    }
    else {
        throw (new Error("This should be unreachable."));
    }
    const matchValue_1 = in_branch(left, tree);
    if (matchValue_1 == null) {
        const matchValue_2 = neg_in_branch(left, tree);
        if (matchValue_2 == null) {
            const matchValue_3 = in_branch(right, tree);
            if (matchValue_3 == null) {
                const matchValue_4 = neg_in_branch(right, tree);
                if (matchValue_4 == null) {
                    return prop_helper(ln, nodes, cons(node, passed), tree);
                }
                else {
                    const neg_right_line = matchValue_4;
                    const neg_left = negate(left);
                    const neg_right_instr_line = new ProofLine(4, ln, prev_instr_line, neg_right_line, neg_left);
                    const down_tree_3 = new ProofBranchLine(1, neg_right_instr_line, tree);
                    const up_tree_3 = prop_helper(ln + 1, append(cons(neg_left, nodes), passed), empty(), down_tree_3);
                    return new ProofTree(1, neg_right_instr_line, up_tree_3);
                }
            }
            else {
                const right_line = matchValue_3;
                const right_instr_line = new ProofLine(4, ln, prev_instr_line, right_line, left);
                const down_tree_2 = new ProofBranchLine(1, right_instr_line, tree);
                const up_tree_2 = prop_helper(ln + 1, append(cons(left, nodes), passed), empty(), down_tree_2);
                return new ProofTree(1, right_instr_line, up_tree_2);
            }
        }
        else {
            const neg_left_line = matchValue_2;
            const neg_right = negate(right);
            const neg_left_instr_line = new ProofLine(4, ln, prev_instr_line, neg_left_line, neg_right);
            const down_tree_1 = new ProofBranchLine(1, neg_left_instr_line, tree);
            const up_tree_1 = prop_helper(ln + 1, append(cons(neg_right, nodes), passed), empty(), down_tree_1);
            return new ProofTree(1, neg_left_instr_line, up_tree_1);
        }
    }
    else {
        const left_line = matchValue_1;
        const left_instr_line = new ProofLine(4, ln, prev_instr_line, left_line, right);
        const down_tree = new ProofBranchLine(1, left_instr_line, tree);
        const up_tree = prop_helper(ln + 1, append(cons(right, nodes), passed), empty(), down_tree);
        return new ProofTree(1, left_instr_line, up_tree);
    }
}

export function propopositional_solver(node) {
    let right, op, left;
    let pattern_matching_result;
    if (node.tag === 1) {
        if ((right = node.fields[2], (op = node.fields[0], (left = node.fields[1], equals(op, new Token(3)))))) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return prop_helper(0, singleton(node), empty(), new ProofBranchLine(0));
        }
        case 1: {
            const up_tree = prop_helper(1, singleton(node), empty(), new ProofBranchLine(1, new ProofLine(0, 0, node), new ProofBranchLine(0)));
            return new ProofTree(1, new ProofLine(0, 0, node), up_tree);
        }
    }
}

